import type { useFormDialog } from './hooks/useFormDialog';
import { HistoryTab } from './HistoryTab';
import { BasicInfoTab } from './tabs';

type DialogModel = ReturnType<typeof useFormDialog>;

export const FormHeader = (dialog: DialogModel) => [
  {
    id: 'info',
    label: 'Thông tin',
    component: <BasicInfoTab formMode={dialog.formMode} formState={dialog.formState} />
  },
  ...(dialog.formMode !== 'add'
    ? [{ id: 'history', label: 'Lịch sử', component: <HistoryTab formMode={dialog.formMode} /> }]
    : [])
];
